import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './ExpandableDescription.module.scss';

type Props = {
    description: string;
};

export const ExpandableDescription = ({ description }: Props) => {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const breakIndex = description.indexOf('<BREAK>');
    const hasBreak = breakIndex !== -1;

    if (!hasBreak) {
        return <p className={styles.description}>{description}</p>;
    }

    const visibleText = description.substring(0, breakIndex);
    const hiddenText = description.substring(breakIndex + 7);

    return (
        <div className={styles.container}>
            <p className={styles.description}>
                {visibleText}
                {isExpanded && hiddenText}
                <button
                    className={styles.toggleButton}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <span className={styles.buttonContent}>
                        {isExpanded ? t('commons.read_less') : t('commons.read_more')}
                        <span className={classNames(styles.triangle, { [styles.triangleExpanded]: isExpanded })} />
                    </span>
                </button>
            </p>

        </div>
    );
};